<template>

  <div>
    <!-- Filters -->
    <!--    <Filters-->
    <!--        :role-filter.sync="roleFilter"-->
    <!--        :plan-filter.sync="planFilter"-->
    <!--        :status-filter.sync="statusFilter"-->
    <!--        :role-options="roleOptions"-->
    <!--        :plan-options="planOptions"-->
    <!--        :status-options="statusOptions"-->
    <!--    />-->

    <b-overlay :show="overlay">
      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="mr-1">
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por marca ou usuário..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="primary"
                    :to="{ name: 'imagens-home-novo' }"
                    class="d-flex"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">Criar</span>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refDataTableImagemHome"
            class="position-relative"
            :items="fetchImagemHome"
            responsive
            :fields="tableColumns"
            primary-key="log_img_id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >

          <template #cell(log_img_id)="data">
            <span>{{ data.item.log_img_id }}</span>
          </template>

          <template #cell(caminho)="data">
            <b-img class="mb-1 mb-sm-0" height="100%" width="120" :src="data.value"
                   :alt="`Imagem id ${data.item.log_img_id}`"/>
          </template>

          <template #cell(cod_marca)="data">
            <span>{{ data.item.marca.cod_marca }}</span>
          </template>

          <template #cell(des_marca)="data">
            <span>{{ data.item.marca.des_marca }}</span>
          </template>

          <template #cell(usuario_nome)="data">
            <span>{{ data.item.usuario.usuario_nome }}</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  title="Visualizar"
                  variant="gradient-primary"
                  :to="{ name: 'imagens-home-edit-id', params: { id: data.item.log_img_id } }"
                  class="btn-icon mr-1"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  title="Deletar"
                  variant="gradient-danger"
                  @click="showModalDeleteImagemHome(data.item.log_img_id)"
                  class="btn-icon"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalUsers"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-imagem-home"
        title="Deletar Imagem Home"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="sim, deletar"
        @ok="deleteImagemHome"
        @cancel="isDeleteModal = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import HbiImagemHomeService from '@/services/SistemaDKP/sls-imagem-home.service';
import useList from './useList';
import Filters from './Filters.vue';

export default {
  components: {
    ModalConfirmation,
    Filters,
  },
  data() {
    return {
      searchInputValue: '',
    };
  },
  methods: {
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const isDeleteModal = ref(false);
    const imagemHomeService = new HbiImagemHomeService();
    const idImagemHomeDelete = ref(null);
    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      fetchImagemHome,
      overlay,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableImagemHome,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useList();

    const showModalDeleteImagemHome = (id) => {
      idImagemHomeDelete.value = id;
      isDeleteModal.value = true;
    };
    const deleteImagemHome = async () => {
      await imagemHomeService.delete(idImagemHomeDelete.value);
      isDeleteModal.value = false;
      refetchData();
    };

    return {

      // Sidebar
      isDeleteModal,

      fetchImagemHome,
      overlay,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTableImagemHome,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      deleteImagemHome,
      showModalDeleteImagemHome,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
